import classNames from 'classnames';
import Link from 'next/link';
import { Fragment } from 'react';

import styles from './Breadcrumb.module.scss';

export interface Path {
    title: string;
    href?: string;
}

interface Props {
    paths: Path[];
}

export function Breadcrumb({ paths }: Props) {
    if (!paths.length) {
        return null;
    }

    return (
        <div className={styles.container}>
            {paths.map((path, index) => {
                if (index === paths.length - 1) {
                    return (
                        <p className={classNames(styles.path, styles.currentPath)} key={path.title}>
                            {path.title}
                        </p>
                    );
                }

                return (
                    <Fragment key={path.title}>
                        <Link
                            className={classNames(styles.path, styles.link)}
                            href={path.href as string}
                            key={path.href}
                        >
                            {path.title}
                        </Link>
                        <span className={styles.separator}>&gt;</span>
                    </Fragment>
                );
            })}
        </div>
    );
}
